import {strings} from '../../services/language';
import TimesheetList from './TimesheetList/TimesheetList';
import {useSearchParams} from 'react-router-dom';

export default function TimesheetListPage() {
  const [searchParams] = useSearchParams();
  const payrollId = searchParams.get('payrollId');
  return (
    <>
      <div className="main-header">
        <h1>{strings('Timesheets')}</h1>
      </div>
      <TimesheetList payrollId={payrollId ? Number(payrollId) : undefined} />
    </>
  );
}
